import iconWarning from 'styles/images/icon_warning.svg';
export const ErrorGuideWithBox = ({ failMsg }) => {
  return (
    <div className='consent-notice-wrap'>
      <div className='consent-notice'>
        <div className='icon-wrap'>
          <img src={iconWarning} alt='경고 아이콘' />
        </div>
        <p className='notice-title'>
          동의서 작성 전<br />
          안내 사항을 확인해 주세요
        </p>
        <p className='notice-description'>
          원활한 진행을 위해 아래 안내 사항을 확인하신 후<br />
          동의서 작성을 이어서 진행할 수 있어요.
        </p>
      </div>
      <div className='info-box'>
        <div>
          <h3>안내 사항</h3>
          <ul>
            <li>{failMsg}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export const ErrorGuide = ({ title, description }) => {
  return (
    <div className='consent-notice-wrap'>
      <div className='consent-notice'>
        <div className='icon-wrap'>
          <img src={iconWarning} alt='경고 아이콘' />
        </div>
        <p className='notice-title'>{title}</p>
        <p className='notice-description'>{description}</p>
      </div>
    </div>
  );
};
